export default __webpack_public_path__ + "images/HC.fb29f4a.png";